module.exports = __webpack_public_path__ + "img/icon-point.fb41cb28.svg";